import { useState } from "react";

import { Button, InputAdornment, TextField, Typography } from "@mui/material";
import classNames from "classnames";
import { GoAlert } from "react-icons/go";
import { IoSync } from "react-icons/io5";

import { MAX_COURSE_DESCRIPTION_LENGTH } from "../../../../../constants";
import { useMyCourseInstructor } from "../../hooks/useMyCourseInstructor";

export function MyCourseDescription() {
	const { course, updateCourseBasicInformation } = useMyCourseInstructor();
	const [description, setDescription] = useState(course?.description ?? "");
	const [descriptionError, setDescriptionError] = useState("");
	const [loading, setLoading] = useState(false);

	if (!course) {
		return null;
	}

	const onClickCancel = () => {
		setDescription(course.description);
	};

	const onClickUpdate = async () => {
		if (
			description.trim() === course.description.trim() ||
			description.trim() === ""
		) {
			return;
		}

		setLoading(true);
		await updateCourseBasicInformation({ description: description.trim() });
		setLoading(false);
	};

	const isDisabled =
		description.trim() === course.description.trim() ||
		description.trim() === "" ||
		loading;
	const isEdited = description !== course.description && !loading;

	return (
		<>
			<div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
				<Typography className="small-title-text bold">
					1. Let students know what this training enables them to do
				</Typography>
				{course.description.trim() === "" && (
					<div>
						<GoAlert className="normal-icon warning-icon" />
					</div>
				)}
				{loading && (
					<div>
						<IoSync className="normal-icon rotation-icon blue-icon" />
					</div>
				)}
			</div>
			<Typography className="normal-text">
				Suppose a student goes through your training. So what? What problems are
				you helping your students overcome? What result are you helping them
				achieve? What knowledge, skills, behaviors, and competencies are you
				transferring? What types of content and equipment do you include?
			</Typography>
			<div className="common-input">
				<TextField
					size="small"
					autoComplete="off"
					id="course-description"
					onChange={(e) => {
						setDescription(
							e.target.value.slice(0, MAX_COURSE_DESCRIPTION_LENGTH),
						);
						if (e.target.value.trim() === "") {
							setDescriptionError("Can't live without it");
						} else {
							setDescriptionError("");
						}
					}}
					className={classNames("item-separator-small", {
						invalid: !!descriptionError,
					})}
					value={description}
					fullWidth
					multiline
					minRows={4}
					placeholder={'Aviation needs "YOU"... Someone needs "YOU"'}
					slotProps={{
						input: {
							className: "normal-text",
							classes: {
								input: "input-placeholder",
							},
							endAdornment: (
								<InputAdornment
									position="end"
									style={{
										alignSelf: "flex-end",
										marginBottom: "7.5px",
										marginRight: "14px",
										alignItems: "flex-end",
									}}>
									<Typography className="normal-text">{`${description.length}/${MAX_COURSE_DESCRIPTION_LENGTH}`}</Typography>
								</InputAdornment>
							),
						},
					}}
				/>
				{descriptionError && (
					<Typography className="small-text invalid-message">
						{descriptionError}
					</Typography>
				)}
			</div>
			<div className="button-container item-separator-small">
				<Button
					className="normal-button disabled-button"
					disabled={!isEdited}
					onClick={onClickCancel}>
					Cancel
				</Button>
				<Button
					disabled={isDisabled}
					className={classNames("normal-button", {
						"primary-button": !isDisabled,
						"disabled-button": isDisabled,
					})}
					onClick={onClickUpdate}>
					Save
				</Button>
			</div>
		</>
	);
}
